/* NB ANNOUNCEMENT ACCESSIBILITY LAYER — site-wide, loaded from layout/theme.liquid.

   Broadcast's native announcement bar carries the content model the operator requires (per-block text,
   optional link, enable/disable, order, marquee layout). What it does NOT carry is accessible motion:

     1. assets/ticker.js clones [data-ticker-text] N times as PLAIN DOM with no aria-hidden, so a screen
        reader reads every message once per clone.
     2. There is no pause control, and nothing inside the bar is focusable, so even a :focus-within rule
        could never fire.
     3. There is no prefers-reduced-motion branch anywhere.

   This file fixes 1 and 2. nb-pdp-v3.css fixes 3. Content is untouched — the operator still edits every
   message in the Theme Editor. DEFECT-06, DEFECT-10, DEFECT-11. */
(function () {
  'use strict';

  function enhance(wrap) {
    if (!wrap || wrap.hasAttribute('data-nb-a11y')) return;
    var holder = wrap.querySelector('.announcement__bar-holder--marquee');
    if (!holder) return;                       // slider layout announces normally; nothing to fix
    wrap.setAttribute('data-nb-a11y', '');

    /* 1 · one accessible reading */
    var slides = wrap.querySelectorAll('.announcement__slide');
    var seen = [], i, t;
    for (i = 0; i < slides.length; i++) {
      t = (slides[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (t && seen.indexOf(t) === -1) seen.push(t);
    }
    var ticker = wrap.querySelector('ticker-bar');
    if (ticker) ticker.setAttribute('aria-hidden', 'true');

    if (seen.length) {
      var ul = document.createElement('ul');
      ul.className = 'nb-announce-sr';
      for (i = 0; i < seen.length; i++) {
        var li = document.createElement('li');
        li.textContent = seen[i];
        ul.appendChild(li);
      }
      wrap.insertBefore(ul, wrap.firstChild);
    }

    /* 2 · a real pause control */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nb-announce-pause';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', 'Pause scrolling announcements');
    btn.textContent = '❘❘';
    btn.addEventListener('click', function () {
      if (wrap.hasAttribute('data-nb-paused')) {
        wrap.removeAttribute('data-nb-paused');
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Pause scrolling announcements');
        btn.textContent = '❘❘';
      } else {
        wrap.setAttribute('data-nb-paused', '');
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Resume scrolling announcements');
        btn.textContent = '▶';
      }
    });
    wrap.appendChild(btn);
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-announcement-wrapper]'), enhance);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);        /* ticker.js clones after load */
  document.addEventListener('shopify:section:load', run);
})();
